import { _changeFilter, _fetchItems, selectItems } from 'actions/lists'
import { useAppDispatch, useAppSelector } from 'hooks/hooks'
import { useEffect } from 'react'

export function useList(filterId, options, defaultOptions = {}) {
    const dispatch = useAppDispatch()
    const { reducerKey } = options

    const fetchList = (newOptions, fetchOptions = {}) => {
        return _fetchItems(newOptions || filterId, { ...options, ...fetchOptions })
    }

    const changeFilter = (filterOptions, forced = false) => {
        // Auto-force fetch for provider matches to allow concurrent fetching
        const shouldForceFetch =
            forced || filterId.includes('provider_matches') || filterOptions.forceFetch
        dispatch(
            _changeFilter(filterId, filterOptions, {
                fetchFunc: fetchList,
                ...options,
                ...(shouldForceFetch ? { forceFetch: true } : {}),
            }),
        )
    }

    const refresh = (forced = false) => {
        changeFilter({ ...defaultOptions, didInvalidate: true }, forced)
    }

    const select = (ids) => {
        dispatch(selectItems(reducerKey, ids, filterId))
    }
    const {
        entities,
        result,
        isFetching,
        filters,
        counts,
        stats = [],
        extra,
        error,
    } = useAppSelector((state) => state[reducerKey])
    const filter = filters[filterId] || {}
    useEffect(() => {
        changeFilter(defaultOptions)
    }, [filterId])

    useEffect(() => {
        // Only refresh if didInvalidate is true and we're not already fetching
        // This prevents an infinite loop while still ensuring the list is refreshed when needed
        if (filter.didInvalidate && !isFetching) {
            changeFilter(defaultOptions)
        }
    }, [filter.didInvalidate, isFetching])

    const searchKey = filter && filter.searchKey
    const count = filter && counts[searchKey]
    const pageNr = (filter && filter.page) || 0
    const pages = result[searchKey] || {}
    const currentPage = pages[pageNr] || []
    return {
        changeFilter,
        entities,
        result,
        select,
        refresh,
        pageNr,
        pages,
        filter,
        count,
        stats,
        extra,
        currentPage,
        isFetching,
        url: options.url,
        error,
    }
}

export const useListPerCountry = (filterId, options, defaultOptions = {}) => {
    const { countries } = useAppSelector((state) => state.countries)
    const result = useList(filterId, options, {
        ...defaultOptions,
        countries,
    })

    useEffect(() => {
        result.changeFilter({ countries, serviceIds: [], page: 0 })
    }, [countries])

    return result
}
